import React from 'react'
import {
  Alert,
  Button,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@common/material'
import ClearIcon from '@mui/icons-material/Clear'
import { Flex } from '@fundamentals'
import { useModal } from '@common/GlobalModal'
import { localizedStrings } from '@core/strings'
import { Laptop, OpenInNew } from '@mui/icons-material'
import { ModalDialogContainer } from '@common/modal'

type DeepLinkType = 'permit' | 'checklist' | 'task'

type OpenInAppModalProps = {
  type: DeepLinkType
  id: number
  onDismiss?: () => void
}

const CUSTOM_URL_SCHEME = 'siteassist-sa://'

const getDeepLinkUrl = (type: DeepLinkType, id: number): string => {
  switch (type) {
    case 'permit':
      return `${CUSTOM_URL_SCHEME}permits/${id}`
    case 'checklist':
      return `${CUSTOM_URL_SCHEME}checklists/${id}`
    case 'task':
      return `${CUSTOM_URL_SCHEME}tasks/${id}`
    default:
      return `${CUSTOM_URL_SCHEME}home`
  }
}

const getTypeLabel = (type: DeepLinkType): string => {
  switch (type) {
    case 'permit':
      return localizedStrings.permit
    case 'checklist':
      return localizedStrings.checklist
    case 'task':
      return localizedStrings.task
    default:
      return ''
  }
}

export const OpenInAppModal: React.FC<OpenInAppModalProps> = ({
  type,
  id,
  onDismiss: onDismissProp,
}) => {
  const { hideModal } = useModal()

  const onDismiss = () => {
    hideModal()
    onDismissProp?.()
  }

  const handleOpenInApp = () => {
    const deepLinkUrl = getDeepLinkUrl(type, id)
    window.location.href = deepLinkUrl
  }

  const typeLabel = getTypeLabel(type)

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.openInApp}
        <IconButton aria-label='close-modal' onClick={onDismiss}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Flex alignItems={'center'} flexDirection={'column'}>
          <Alert severity={'info'} sx={{ mb: 3 }}>
            {localizedStrings.openInAppMessage(typeLabel)}
          </Alert>
          <Button
            sx={{ mb: 3, width: '200px' }}
            startIcon={<OpenInNew />}
            variant={'contained'}
            onClick={handleOpenInApp}
          >
            {localizedStrings.openInApp}
          </Button>
          <Button
            sx={{ mb: 3, width: '200px' }}
            startIcon={<Laptop />}
            variant={'outlined'}
            onClick={onDismiss}
          >
            {localizedStrings.continueOnWeb}
          </Button>
        </Flex>
      </DialogContent>
    </ModalDialogContainer>
  )
}
